import React, { useEffect, useState } from "react";
import { Heart, X, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "../../store/api";
import customerApi from "../../hq/customerApi";

export function CrushDrawer({ crush, setCrush, onClose, onDone }) {
  const items = Object.values(crush);
  const [form, setForm] = useState({ name: "", email: "", phone: "", address: "", delivery_notes: "", accept_alternatives: true, alternatives_note: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("heritage-customer-token")) return;
    customerApi.get("/customer/me").then((r) => {
      const me = r.data || {};
      const a = me.address || {};
      const addr = typeof a === "string" ? a : [a.line1, a.line2, a.suburb, a.city, a.postcode].filter(Boolean).join(", ");
      setForm((f) => ({ ...f, name: me.name || f.name, email: me.email || f.email, phone: me.phone || f.phone, address: addr || f.address }));
    }).catch(() => {});
  }, []);

  const update = (id, patch) => setCrush((c) => ({ ...c, [id]: { ...c[id], ...patch } }));
  const remove = (id) => setCrush((c) => { const n = { ...c }; delete n[id]; return n; });

  const submit = async (e) => {
    e.preventDefault();
    if (items.length === 0) return toast.error("Heart at least one dahlia first.");
    if (!form.name.trim() || !form.email.trim()) return toast.error("We need your name and email to shoot your shot.");
    setBusy(true);
    try {
      const r = await api.post("/crush/requests", { ...form, items: items.map((i) => ({ variety_id: i.variety_id, qty: Number(i.qty) || 1, note: i.note || "" })) });
      onDone(r.data);
    } catch (err) { toast.error(err?.response?.data?.detail || "That didn't send , try again in a moment."); }
    finally { setBusy(false); }
  };

  return (
    <div className="crush-overlay" onClick={onClose}>
      <aside className="crush-drawer" onClick={(e) => e.stopPropagation()} data-testid="crush-drawer">
        <header>
          <div><p className="crush-kicker">Your Crush List</p><h2>{items.length ? `${items.length} dahlia${items.length === 1 ? "" : "s"} caught your eye` : "Nobody yet , go flirt with the collection"}</h2></div>
          <button type="button" onClick={onClose} aria-label="Close" data-testid="crush-drawer-close"><X className="w-5 h-5" /></button>
        </header>
        <div className="crush-lines">
          {items.map((i) => (
            <div key={i.variety_id} className="crush-line" data-testid={`crush-line-${i.variety_id}`}>
              <img src={i.image} alt="" />
              <div className="grow">
                <strong>{i.name}</strong>
                <input value={i.note} onChange={(e) => update(i.variety_id, { note: e.target.value })} placeholder="A note for Heritage (optional)" data-testid={`crush-line-note-${i.variety_id}`} />
              </div>
              <label className="crush-qty">Cuttings<input type="number" min="1" max="20" value={i.qty} onChange={(e) => update(i.variety_id, { qty: e.target.value })} data-testid={`crush-line-qty-${i.variety_id}`} /></label>
              <button type="button" onClick={() => remove(i.variety_id)} aria-label="Remove" data-testid={`crush-line-remove-${i.variety_id}`}><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
        <form onSubmit={submit} className="crush-form" data-testid="crush-form">
          <p className="crush-kicker">About you</p>
          <div className="two">
            <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your name" data-testid="crush-name" />
            <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" data-testid="crush-email" />
          </div>
          <div className="two">
            <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Contact number" data-testid="crush-phone" />
            <input value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} placeholder="Delivery address (or ‘pickup’)" data-testid="crush-address" />
          </div>
          <textarea value={form.delivery_notes} onChange={(e) => setForm({ ...form, delivery_notes: e.target.value })} placeholder="Delivery details or timing , rural delivery, best month, anything we should know" rows={2} data-testid="crush-delivery-notes" />
          <label className="crush-check">
            <input type="checkbox" checked={form.accept_alternatives} onChange={(e) => setForm({ ...form, accept_alternatives: e.target.checked })} data-testid="crush-alternatives" />
            <span>If a first choice can't be propagated, I'm open to Heritage suggesting a similar variety.</span>
          </label>
          {form.accept_alternatives && (
            <input value={form.alternatives_note} onChange={(e) => setForm({ ...form, alternatives_note: e.target.value })} placeholder="Any colours or forms you'd happily fall for instead?" data-testid="crush-alternatives-note" />
          )}
          <p className="crush-small">This is an expression of interest , no payment now, nothing reserved yet. Heritage confirms availability and pricing first.</p>
          <button type="submit" disabled={busy || items.length === 0} className="crush-shoot" data-testid="crush-shoot">
            {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Heart className="w-5 h-5" fill="currentColor" />} SHOOT YOUR SHOT ♡
          </button>
        </form>
      </aside>
    </div>
  );
}
